<template>
  <div>
    <div class="top-title l-container">
      <h3>特集一覧</h3>
    </div>
    <a-divider />
    <!-- SLIDE -->
    <div>
      <CarouselCenterMode />
    </div>

    <div class="container l-container">
      <!-- LIST1 -->
      <div class="list1">
        <div class="detail">
          <SectionContentTitle
            :lineType="lineType.horizontal"
            :titleContent="titleContent[0]"
          />
          <CardRecommended :onMove="onMove"/>
        </div>
      </div>
      <!-- LIST 2 -->
      <div class="list2">
        <div class="detail">
          <SectionContentTitle
            :lineType="lineType.horizontal"
            :titleContent="titleContent[1]"
          />
          <TabsCard />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CarouselCenterMode from '@/components/compound/CarouselCenterMode'
import { SectionContentTitle } from '@/components/compound'
import TabsCard from './components/CardCategTabs'
import CardRecommended from './components/CardRecommended'
import { GET_SPECIAL_EVENT_LIST } from '@/store/modules/spec/actions'

export default {
  components: {
    SectionContentTitle,
    TabsCard,
    CardRecommended,
    CarouselCenterMode
  },
  data() {
    return {
      titleContent: ['あなたにおすすめの特集', 'カテゴリーから探す'],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      specialList: {},
      banner: []
    }
  },
  mounted() {
    this.getSpecialEvent()
    // this.getBannerEvent()
  },
  methods: {
    // getSpecialEvent() { 
    //   this.$store.dispatch(GET_SPECIAL_EVENT_LIST).then((data) => {
    //     this.specialList = data
    //     console.log('sssssssss')
    //     console.log(1, this.specialList)

    //   })
    // },
    // getBannerEvent() {
    //   this.$store.dispatch(GET_BANNER_SPECIAL_EVENT_LIST).then((data) => {
    //     this.banner = data.bannerSpecialEventList
    //     console.log(2, this.banner)
    //   })
    // },
    onMove() {
      this.$router.push({path: 'bs-01-010', name: 'BS_SPE_01_010_特集ページ', params: { spFeatureId: '0000000678' }})
    },
    getSpecialEvent() {
      this.$store.dispatch(GET_SPECIAL_EVENT_LIST).then((data) => {
        this.specialList = data
        this.banner = data.bannerSpecialEventList
      })
    }
   
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
